import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-amber-50 via-orange-50 to-amber-100"></div>
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, #8B4513 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side - Text content */}
          <div className="text-left space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full border border-amber-200">
              <Sparkles className="w-4 h-4 text-amber-600" />
              <span className="text-sm font-medium text-amber-900">Doces Artesanais Portugueses</span>
            </div>
            
            <h1 className="hero-title text-5xl md:text-7xl font-bold leading-tight">
              <span className="text-amber-950">Ser Tão</span>
              <br />
              <span className="text-amber-700">Doce</span>
            </h1>
            
            <p className="hero-subtitle text-xl md:text-2xl text-amber-800 leading-relaxed">
              Brigadeiros e bombons artesanais que transformam cada momento em uma experiência única
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => scrollToSection('menu')}
                size="lg" 
                className="hero-cta bg-amber-700 hover:bg-amber-800 text-white px-8 py-6 text-lg rounded-full transition-all duration-300 hover:scale-105 hover:shadow-xl"
              >
                Ver Cardápio
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button 
                onClick={() => scrollToSection('pricing')}
                size="lg" 
                variant="outline"
                className="border-2 border-amber-700 text-amber-700 hover:bg-amber-700 hover:text-white px-8 py-6 text-lg rounded-full transition-all duration-300"
              >
                Fazer Pedido
              </Button>
            </div>

            <div className="flex items-center gap-8 pt-4">
              <div className="text-center">
                <div className="text-3xl font-bold text-amber-900">30+</div>
                <div className="text-sm text-amber-700">Sabores</div>
              </div>
              <div className="h-12 w-px bg-amber-300"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-amber-900">100%</div>
                <div className="text-sm text-amber-700">Artesanal</div>
              </div>
              <div className="h-12 w-px bg-amber-300"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-amber-900">★ 5.0</div>
                <div className="text-sm text-amber-700">Avaliação</div>
              </div>
            </div>
          </div>

          {/* Right side - Image */}
          <div className="hero-image-container relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img 
                src="/images/first.png"
                alt="Foto Principal Brigadeiros"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-amber-900/30 to-transparent"></div>
            </div>
            
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 transform hover:scale-110 transition-transform duration-300">
              <div className="flex items-center gap-3">
                <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_1d505a5f-a544-4c6e-8862-fec39bdf81d8/artifacts/gj3rnkah_image.png"
                    alt="Ser Tão Doce Logo"
                    className="w-12 h-12 object-contain"
                  />
                </div>
                <div>
                  <div className="font-bold text-amber-900">Waleria Mapeli</div>
                  <div className="text-sm text-amber-700">Mestre Doceira</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
};

export default Hero;
